// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../admin/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.title[data-v-69c81a37] {\n\tmargin-top: 1.875em;\n}\n", ""]);
// Exports
module.exports = exports;
